import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import { Outlet } from "react-router-dom";
import React from "react";

import { Yna } from "../../components/common/logo";
import { authStyles } from "../../styles/authStyles";

export default observer(({ children }: { children?: React.ReactNode }) => {
  const { classes } = authStyles();
  return (
    <SWrapper>
      <SLoginWrapper>
        <SLeftSide>
          <Yna className={classes.logo} />
        </SLeftSide>
        <SRightSide>
          <SLoginFormWrapper>
            {children || <Outlet />}
          </SLoginFormWrapper>
        </SRightSide>
      </SLoginWrapper>
    </SWrapper>
  );
});

const SWrapper = styled.div`
  min-height: 100vh;
  background-color: #ff3147;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  background-image: url("/bg.svg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;

const SLoginWrapper = styled(Grid)`
  width: 100%;
  display: flex;
  margin: 0;
`;

const SLeftSide = styled(Grid)`
  width: 50%;
  height: 100%;

  @media (max-width: 940px) {
    display: none;
  }
`;

const SRightSide = styled(Grid)`
  display: flex;
  border-radius: 24px 0px 0px 24px;
  width: 50%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ffffff;

  @media (max-width: 940px) {
    width: 100%;
  }
`;

const SLoginFormWrapper = styled(Grid)`
  margin: 0 auto;
  width: 506px;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: #a8a7a7;
  align-items: center;
  display: grid;
  align-content: center;
`;
